import React from "react"

import style from "./style.module.scss"

const Banner = () => {
  if (typeof window !== `undefined`) {
    setTimeout(() => {
      window.location.replace("https://tascombank.ua")
    }, 10000)
  }
  return (
    <div className={style.Banner}>
      <div className={style.Text}>
        Ця акція завершена
        <div>
          Деталі за посиланням
          <br></br>
          <a href={"https://tascombank.ua"}>tascombank.ua</a>
        </div>
      </div>
    </div>
  )
}

export default Banner
